









































































































































import Vue from 'vue';

import Services from '@/services';

import Time from '@/utils/Time';

import SolidUser from '@/models/users/SolidUser';
import User from '@/models/users/User';

import SettingsModal from '@/components/modals/SettingsModal.vue';
import UserAvatar from '@/components/UserAvatar.vue';

interface MenuOption {
    name: string;
    icon: string;
    handler: Function;
}

export default Vue.extend({
    components: {
        UserAvatar,
    },
    directives: {
        closeMenu: {
            bind: el => el.addEventListener('click', () => Services.$ui.closeMenu()),
        },
    },
    computed: {
        user(): User {
            return this.$auth.user!;
        },
        menuOptions(): MenuOption[] {
            const optionHandler = (handler: Function) => async () => {
                // If this isn't done, logging out in offline mode causes a weird UI
                // interaction with the appearance animation of the confirmation modal.
                // TODO this shouldn't be necessary, debug further.
                await Time.wait(0);

                handler();
            };

            return [
                { name: 'Settings', icon: 'wrench', handler: optionHandler(() => this.$ui.openModal(SettingsModal)) },
                { name: 'Log out', icon: 'logout', handler: optionHandler(() => this.$auth.logout()) },
            ];
        },
        userWebId(): string | null {
            return this.$auth.user instanceof SolidUser
                ? this.$auth.user.id
                : null;
        },
    },
    mounted() {
        this.$ui.setMobileMenu(this.$refs['mobile-menu'] as HTMLElement);
        this.$ui.setDesktopMenu(this.$refs['desktop-menu'] as HTMLElement);
        this.$ui.addMenuTrigger(this.$refs['button'] as HTMLButtonElement);
        this.$ui.setMyCollection((this.$refs['my-collection'] as Vue).$el as HTMLElement);
    },
    beforeDestroy() {
        this.$ui.setMobileMenu(null);
        this.$ui.setDesktopMenu(null);
        this.$ui.removeMenuTrigger(this.$refs['button'] as HTMLButtonElement);
        this.$ui.setMyCollection(null);
    },
});
